import React from "react";
import "./jumbotron.scss";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface IProps {
  title: string;
  content?: string;
  link?: { label: string; url: string; icon?: IconDefinition };
}

export default function Jumbotron(props: IProps) {
  const { title, content, link } = props;

  return (
    <div className="jumbotron-container">
      <h1 className="jumbotron-title">{title}</h1>
      {content && <p className="jumbotron-content">{content}</p>}
      {link ? (
        <a href={link?.url} target="_blank" rel="noreferrer" className="jumbotron-link">
          {link?.label} {link?.icon ? <FontAwesomeIcon icon={link?.icon} /> : null}
        </a>
      ) : null}
    </div>
  );
}
